<div class="promo-ticker" role="region" aria-label="New user Lucky Bucks promotion">
  <p class="promo-ticker__sr">{{ srText }}</p>
  <div class="promo-ticker__viewport">
    <div class="promo-ticker__track">
      <div class="promo-ticker__group" *ngFor="let copy of copies" aria-hidden="true">
        <span class="promo-ticker__item" *ngFor="let item of items">
          <span class="promo-ticker__live"></span>
          <span class="promo-ticker__badge">+$5</span>
          <span class="promo-ticker__pair">{{ item.pair }}</span>
          <span class="promo-ticker__text">{{ item.text }}</span>
          <span class="promo-ticker__chg">{{ item.tag }}</span>
        </span>
      </div>
    </div>
  </div>
</div>
